module.exports = __webpack_public_path__ + "static/media/cutsglare_korean_00157.a0812e48.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/kr/cutsglare_korean_00157.png
// module id = 2681
// module chunks = 0